import CompanyPageForm from './company-page-form'

export default CompanyPageForm;